<template>
  <div>
    <div class="player">
<!--      <video id='myVideo' ref="videoPlayer" preload="auto" webkit-playsinline="true"-->
<!--             playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"-->
<!--             x5-video-player-fullscreen="true" x5-video-orientation="portraint">-->
<!--        <source :src="video_src" type="application/x-mpegURL">-->

<!--      </video>-->
      <div v-if="live_status==1">
        <video id='myVideo' ref="videoPlayer" class="video-js vjs-default-skin"
               playsinline
               x5-video-player-fullscreen="true"
               x5-playsinline
               webkit-playsinline
               autoplay
               allow="autoplay"
               x-webkit-airplay="true"
               x5-video-player-typ="h5">
          <source :src="video_src" type="application/x-mpegURL">
        </video>
      </div>

    </div>

<!--    礼物特效-->
    <div>
      <div class="test_box" v-if="giftAnimation">
        <img v-if="showGiftList.length" :src="showGiftList[0].giftImage" alt="">
        你赠送{{showGiftList.length ? showGiftList[0].liveGiftName : ''}}
      </div>

      <h1>当前排队的礼物长度{{showGiftList.length}}</h1>
      <div class="btn_box">
        <button v-for="(item,itemI) in allList" :key="itemI" @click="giftParams.giftIndex = itemI"> {{item.liveGiftName}}</button>
        <div>
          <button @click="giftParams.giftNum = 1">按钮×1</button>
          <button @click="giftParams.giftNum = 2">按钮×2</button>
          <button @click="giftParams.giftNum = 3">按钮×3</button>
        </div>
        <div @click="sendGift" class="mt50">发送</div>
      </div>
    </div>

      <div class="head-live-box" v-if="comeInAnimation">
        <div class="left-justifying">
          <div class="left-justifying">
            <img src="" alt="" />
            <div class="gift-txt">人可何赠送您</div>
          </div>
          <div class="gift-box left-justifying">
            <img src="https://rdimg.rundejy.com/web/runde_admin/icon_奖杯-1.png" alt="" /> <span>x5</span>
          </div>

        </div>

      </div>

    <div>
      <div class="launch-btn-box">
        <wx-open-launch-weapp id="launch-btn" :username="username" :path="pathUrl" ref="subscribeBtn">
          <script type="text/wxtag-template">
            <style>
              .btn2 {
              width: 60vw;background: #3c8ee5;
                color: #282828;padding: 2.66667vw;
              }
            </style>
            <button class="btn2">银企跑腿小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>


</template>

<script>



import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import {getWechat, zhoboListDes} from "@/api/zhibo";
// import videoDome from './components/progressBar'
const jweixin = require('jweixin-module');
export default {
  name: "test",
  components: {

  },
  data(){
    return {
      video_cover:'https://dev-api.itos.cn/storage/admin/images/0e445ce9a8be4e48716105ae25f8e12c.png',
      video_src:'',
      durationTime: 0,
      currentTime: "00:00", //当前时间
      pvideo: null, //视频容器
      timer: null, //定时器
      video_is_show: false,
      audioURL:'https://itkc.itos.cn/uploads/2021-9-16/bandicam%202021-10-09%2015-39-57-668.mp4',
      currentDuration: "00:00",
      percent: 0,
      playing: true,
      second: 0, // 总时长秒数
      duration: 0, // 总时长
      player: null,
      live_status: 0, // 1直播中 0 无
      phoneType: 1, // 1安卓 2:ios
      options: {
        muted: false, // 是否静音
        autoplay: false, // 播放器准备好之后，是否自动播放 【默认false】
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        //aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        controls: false, // 是否显示底部控制栏
        poster: 'xxx', // 视频封面图地址
        loop: false, // 是否循环播放:true/false
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
         controlBar: {
           children: [
             {name: 'playToggle'}, // 播放按钮
             {name: 'currentTimeDisplay'}, // 当前已播放时间
             {name: 'progressControl'}, // 播放进度条
             {name: 'durationDisplay'}, // 总时间
             {
               name: 'volumePanel', // 音量控制
               inline: false, // 不使用水平方式
             },
             {name: 'FullscreenToggle'} // 全屏
           ]
         }
      },
      // 礼物特效
      allList: [ //总的礼物列表
        {giftImage:'https://rdimg.rundejy.com/web/runde_admin/icon_奖杯-1.png',liveGiftName: '奖杯'},
        {giftImage:'https://rdimg.rundejy.com/web/runde_admin/icon_鼓掌-1.png',liveGiftName: '鼓掌'}
      ],
      showGiftList: [], // 弹层礼物列表  // '礼物1','礼物2'
      giftAnimation: false, // 是否显示礼物动画
      giftParams: {
        giftIndex: '', // 点击的是礼物列表的第几个
        giftNum: 1,   // x1x2x3
        giftTime: 2000 ,// css里的animation mymove也是一样2s
      },
      comeInAnimation: false, // 是否显示有人进来
      ws: null,//建立的连接
      wsuri:'', // ws wss
      lockReconnect: false, // 连接失败不进行重连
      maxReconnect: 10, // 最大重连次数，若连接失败
      templateIds: ['e4AtP6PBnosUZ5-d6SXQbQ-iEkfwU0s1m8STzFiaX4c'],
      username: 'gh_806460f3110a', // gh_ 开头的原始小程序ID
      pathUrl: '/make_speed/router/router', // 一定要以 .html 结尾
    }
  },
  mounted() {

  },
  destroyed() {
    //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  created() {
    var arr = [{title: "全场九折券",type: "discount",discount: 90,id:22},{title: "全场九折券",type: "discount",discount: 90,id:28},{title: "全场九折券",type: "discount",discount: 98,id:29},{title: "减50",type: "subsidy",discount: 50,id:31},{title: "减10",type: "subsidy",discount: 10,id:32}]

    var arrDis = [] // 折扣
    var arrSub = [] // 减

    for(var i=0; i<arr.length; i++) {
      if (arr[i].type == 'discount') {
        arrDis.push(arr[i]);
      } else {
        arrSub.push(arr[i]);
      }
    }
    console.log('折扣',arrDis)
    console.log('减',arrSub)
    var max= Math.min.apply(Math, arrDis.map(function(o) {return o.id})) //打印出id最xiao的值
    // 打印出id最大的对象
    for(var keys in arrDis){
      if(arrDis[keys].id == max){
        console.log('最大值对象',arrDis[keys])
      }
    }
    console.log('max',max)
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
      this.phoneType = 1 // isAndroid
      // alert("安卓机！")
    }
    if (isIOS) {
      // alert("苹果果机！")
      this.phoneType = 2 //  isIOS

    }
    this.phoneType = 2 //  isIOS
    this.live_id = 2
    // this.getDes()
    // this.iniWs()
    // this.getWxDes()
    this.wxSubscribe()
  },
  methods: {
    //页面关闭或刷新时触发
    pageHide() {
      this.$store.commit("setWechatSignUrl", '');
    },
    wxSubscribe(){ // 初始化微信
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        console.log('ios')
      } else {
        console.log('安卓')
        pageUrl = location.href.split('#')[0] // encodeURIComponent
      }

      var data = {
        liveUrl: pageUrl//pageUrl
      }
      console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['wx-open-launch-weapp'],
            openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          //是否支持分享
          jweixin.checkJsApi({
            jsApiList: ['wx-open-launch-weapp'],
            success: function (res) {
              console.log(res)
            }
          });
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            console.log('ready')
          })
          const btn = this.$refs.subscribeBtn;
          btn.addEventListener('launch', function (e) {
            console.log('success');
          });
          btn.addEventListener('error', function (e) {
            console.log('fail', e.detail);
          });
          btn.addEventListener('WeixinOpenTagsError', function (e) {
            console.error('fail',e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
          });
        } else {
          this.$toast(res.message)
        }
      })
    },
    iniWs(){ // 初始化
      //const wsuri = "ws://sms.填写您的地址.com/websocket/" + this.charId; //ws地址
      // "type":"join","liveroomId":"2","uid":2
      const wsuri = 'ws://8.134.82.180:2346/ws/liveroom'
      //建立连接
      var uid = 2
      var liveroomId = 2
      var type1 = 'join'
      this.ws = new WebSocket(wsuri+'?liveroomId='+liveroomId+'&type='+type1+'&uid='+uid);

      //连接成功
      this.ws.onopen = this.wsOnopen;
      //连接错误
      this.ws.onerror   = this.wsOnerror
      //接收信息
      this.ws.onmessage = this.wsOnmessage;
      //连接关闭
      this.ws.onclose = this.wsOnclose;
    },
    wsOnopen(e){
      console.log('WebSocket连接成功', e)
    },
    wsOnerror(e) {
      console.log('WebSocket连接发生错误', e)
      this.reconnect()
    },
    wsOnmessage(e){
      console.log(e)
      try {
        console.log('WebSocket获取数据', e)
        const data = JSON.parse(e.data);
        console.log(data)
        // [].push.apply(this.cache, [data])
        // 消息获取成功，重置心跳
        // heartCheck.start(this.socket, this.queryParams)
      } catch (e) {
        console.error('e: ', e)
      }
    },
    wsOnclose(e) { //  // 关闭
      console.log('connection closed (' + e.code + ')')
      this.wsLinked = false;
      // setTimeout(() => {
      //   this.iniWs()
      // },10000)

      this.reconnect()
    },
    reconnect() { //  重连
      console.log('尝试重连')
      if (this.lockReconnect || this.maxReconnect <= 0) return
      setTimeout(() => {
        this.maxReconnect-- // 不做限制 连不上一直重连
        this.iniWs()
      }, 3 * 1000)
    },
    sendGift() { // 礼物特效
      // 选择x1x2x3拼接数组 或者是监听礼物接口的回调数据拼接进showGiftList
      for(let i=1;i<= this.giftParams.giftNum; i++) {
        let activeItem = this.allList[this.giftParams.giftIndex];
        this.showGiftList.push(activeItem);
      }

      this.$nextTick(()=>{
        if(!this.giftAnimation) { // 动画已经停止了 点了新的礼物 执行新的定时器
          this.giftAnimation = true;
          this.comeInAnimation = true
          let commeAnimation = setInterval(()=>{
            clearInterval(commeAnimation);
            this.comeInAnimation = false;
          },2000)
          let giftAnimation = setInterval(() => {
            if(this.showGiftList.length ===1) { // 最后一个数组 也是要停止定时器
              this.showGiftList.shift();
              clearInterval(giftAnimation);
              this.giftAnimation = false;
            }else if(this.showGiftList.length) { // 有长度的话 就必须要删除数组
              this.showGiftList.shift();
            }else { //  没有数组的时候 就要停止定时器
              clearInterval(giftAnimation);
              this.giftAnimation = false;
            }
          }, this.giftParams.giftTime);
        }else {}// 正在进行动画的话 就不再添加定时器
      })
    },
    autoPlayVideo() {
      //页面初始化加载完毕自动播放视频
      this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady(res) {
        console.log('视频可以播放了',res);
        this.on("loadedmetadata",function(){
          console.log("获取资源长度完成 ")
        })
        this.on("canplaythrough",function(){
          console.log("视频源数据加载完成")
        })
        this.on("waiting", function(){
          console.log("等待数据")
        });
        this.on("play", function(){
          console.log("视频开始播放")

        });
        // 监听视频播放开始
        this.on("playing", function(){
          console.log("视频播放中")
        });
        this.on("error", function(){
          console.log("加载错误")
        });
        // this.player.on('playing', function () {
        //   // 监听视频播放开始
        //   this.player.hide();
        //   this.player.hide();
        // });

      });

    },
    getDes(){
      zhoboListDes(this.live_id).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
          this.live_info = res.data
          this.video_src = res.data.play_url // res.data.pull_url // m3u8
          this.video_cover = res.data.cover
          this.video_title = res.data.title
          this.goodsList = res.data.goods
          this.likesNumber = res.data.likes
          this.clickNumber = res.data.click
          this.live_status = res.data.live_status
          if (this.video_src != null && this.live_status==1){
            setTimeout(() => {
              //通知父组件关闭
              // console.log('播放')


              if (this.phoneType ==2) { //2ios
                // 兼容微信(微信可以自动播放)
                console.log('ios')

                this.options.controls = true
                this.autoPlayVideo()

              } else { // 1 安卓
                this.autoPlayVideo()
              }

            }, 900);
          }

          // 调用互动消息
          // this.initDom(); // 获取消息列表高度
          // const data = new Array(20).fill('');
          // this.queue(data);
          // setTimeout(() => {
          //   const list = new Array(10).fill('');
          //   this.queue(list);
          // }, 10000);
          // 调用互动消息end
          // const secounds = 5
          // let num = 0
          // const timer = setInterval(() => {
          //   if(num < secounds) {
          //     num++
          //   }else {
          //     clearInterval(timer)
          //     // alert('自定义函数在这里调用')
          //     this.createVideo()
          //   }
          // }, 1000) // 这里的时间不要忘记，否则没有效果
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    getWxDes(){ // 获取微信信息
      var url = location.href.split('#')[0]
      var data = {
        liveUrl:url
      }
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['wx-open-subscribe', 'launchAppLication'],
            openTagList: ['wx-open-subscribe', 'wx-open-subscribe-dialog']
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              const btn = this.$refs.subscribeBtn;
              btn.addEventListener('success', ({detail}) => {
                var content2 = JSON.parse(detail.subscribeDetails)
                console.log('2222',content2)
                for (var i in content2) {
                  if (i === this.templateIds[0] || i === 'e4AtP6PBnosUZ5-d6SXQbQ-iEkfwU0s1m8STzFiaX4c') {
                    let status = JSON.parse(content2[i]).status
                    console.log(status)
                    console.log(this.content2)
                    if (status === 'accept') {
                      // 这里跟后端要个接口，绑定；
                       console.log('綁定')
                    } else if (status === 'reject') {
                      alert('拒绝授权')
                    }
                  }
                }
              });
              btn.addEventListener('error', (e) => {
                alert('授权失败了，请重试')
              });
            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    getInfo() {
      // 这里是后去config得基本信息（跟后端要接口 wx.$api.index.wpaySubscribeH5Info  别看不懂，这是封装的请求接口而已换成你自己的就行了）
      wx.$api.index.wpaySubscribeH5Info(location.href.split('#')[0], ['chooseWXPay', ]).then(res1 => {
        let w_pay = JSON.parse(res1.data)
        jweixin.config({
          debug: false,
          appId: w_pay.appId,
          timestamp: w_pay.timestamp,
          nonceStr: w_pay.nonceStr,
          signature: w_pay.signature,
          jsApiList: ['wx-open-subscribe', 'wx-open-launch-app', 'launchAppLication'],
          openTagList: ['wx-open-subscribe', 'wx-open-launch-app', 'wx-open-subscribe-dialog']
        })
        // config 准备好了那么就开始操作了，
        jweixin.ready(() => {
          // wx-open-subscribe 原生绑定点击事件
          this.$nextTick(() => {
            const btn = this.$refs.subscribeBtn;
            btn.addEventListener('success', ({
                                               detail
                                             }) => {
              this.content2 = JSON.parse(detail.subscribeDetails)
              for (var i in this.content2) {
                if (i === this.templateIds[0] || i ===
                  'EZcWzqrLdU-2Ax6KILdv9uSf6ANbHka7CbYG2KGahPk') {
                  let status = JSON.parse(this.content2[i]).status
                  console.log(status)
                  console.log(this.content2)
                  if (status === 'accept') {
                    // 这里跟后端要个接口，绑定；
                    wx.$api.index.subscribeH5(1).then(res => {
                      wx.showLoading({
                        title: res.data,
                        icon: 'none',
                      })
                      // 获取卡权益
                      // this.indexInfo();
                      setTimeout(function() {
                        wx.hideLoading();
                      }, 1000)
                    })
                  } else if (status === 'reject') {
                    alert('拒绝授权')
                  }
                }
              }
            });
            btn.addEventListener('error', (e) => {
              alert('授权失败了，请重试')
            });
          })
        })
      }).catch(err => {
        wx.showToast({
          title: err.message,
          icon: 'none'
        })
      })
    },
  },
  watch: {
    //进度条变化
    percent(val) {
      let value = parseInt(val * 100) + "%";
      this.$refs.progress.style.width = value;
      this.$refs.progressBtn.style.left = parseInt(val * 100 - 5) + "%";
    },
    currentTime(val) {
      this.handle(val);
    }
  }
}
</script>

<style lang="scss" scoped>
.head-live-box{
  position: fixed;
  top: 300px;
  left: -160px;z-index: 100;
  animation: mymove 2s infinite;
  border: 2px solid #fae7b8;
  border-radius: 60px;color: #FFFFFF;
  padding: 10px 20px;max-width: 50%;background: rgba(0,0,0,0.8);
  img{
    width: 60px;height: 60px;background: #cccccc;border-radius: 80px;display: inline-block;margin-right: 10px;
  }
  .gift-box {
    margin-left: 10px;
    img{
      width: 50px;height: auto;
    }
    span{
      font-size: 40px;font-weight: bold;
      -webkit-animation: living 3s linear infinite;
    }
  }
}
@keyframes living {
  0%{
    transform: scale(1);
    //opacity: 0.5;
  }
  50%{
    transform: scale(1.5);
    //opacity: 0;   /*圆形放大的同时，透明度逐渐减小为0*/
  }
  100%{
    transform: scale(1);
    //opacity: 0.5;
  }
}
#myVideo{
  width: 750px;height: 100vh;object-fit: fill
}
.player {
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
// background: #eee;
//.img-gif {
  //  width: 420px;
  //  height: 70px;
  //  border: 3px solid rgba(238, 230, 255, 1);
  //  border-radius: 40px 40px 4px 40px;
  //  background: url("../../../../assets/common/audio-gif.gif") no-repeat center;
  //  margin: 0px auto;
  //}
.progress-wrapper {
  //display: flex;
  align-items: center;
  width: 95%;
  margin: 0px auto;
  padding: 10px 0;
.progress-bar-wrapper {
  flex: 1;
  margin-right: 5px;
.progress-bar {
  height: 30px;
  cursor: pointer;
.bar-inner {
  position: relative;
  top: 13px;
  height: 4px;
  background: rgba(238,229,255,1);
.progress {
  position: absolute;
  height: 100%;
  background-color: #bc99ff;
}
.progress-btn-wrapper {
  position: absolute;
  left: -8px;
  top: -13px;
  width: 30px;
  height: 30px;
.progress-btn {
  position: relative;
  top: 7px;
  left: 7px;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #bc99ff;
}
}
}
}
}
.time {
  color: rgba(238, 229, 255, 1);
  font-size: 26px;
  width: 110px;
  text-align: left;display: block;
}
}
.operators {
  cursor: pointer;
  text-align: center;
img{
  vertical-align: middle;
  margin: 0 20px;
}
}
}


/* video.js样式修改 */
.video-js { /* 给.video-js设置字体大小以统一各浏览器样式表现，因为video.js采用的是em单位 */
  font-size: 14px;
}

.video-js button {
  outline: none;
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 { /* 视频占满容器高度 */
  height: 100%;
  background-color: #161616;
}

.vjs-poster {
  background-color: #161616;
}

.video-js{
  .vjs-big-play-button { /* 中间大的播放按钮 */
    font-size: 30px !important;
    line-height: 50px;
    height: 50px;
    width: 50px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    background-color: rgba(0, 0, 0, .3);
    border-width: 0;
    margin-top: 20px;
    margin-left:-20px;text-align: center!important;
    position: absolute;left: 50%;
  }
}

.video-js.vjs-paused .vjs-big-play-button { /* 视频暂停时显示播放按钮 */
  display: block;
}

.video-js.vjs-error .vjs-big-play-button { /* 视频加载出错时隐藏播放按钮 */
  display: none;
}

.vjs-loading-spinner { /* 加载圆圈 */
  font-size: 30px;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-top: 30px;
  margin-left: 30px;
}


/**礼物特效**/
.mt50 {
  margin-top: 50px;background: #3c8ee5;height: 88px;margin-bottom: 50px;text-align: center;line-height: 88px;
}
.btn_box {
  position: fixed;
  bottom: 0;
  button {
    width: 200px;
  }
}
.test_box {
  animation: mymove 2s infinite;
  height: 30px;
  position: fixed;
  top: 100px;
  left: -160px;
  img {
    width: 50px;
    vertical-align: middle;
  }
}
@keyframes mymove { //滑动出来1s 停留展示1s
  0% {left: -160px;display: none;}
  1% {left: -160px;display: block;}
  50% {left: 200px}
  99% {left: 200px}
  100% {left: 200px;display: none;}
}

/* 订阅消息 */
.subscribe {
  color: #89663f;
  width: 100%;
  padding: 0 100px;
  display: inline-block;
  box-sizing: border-box;
  margin-top: 50px;
  display: flex;
  /* -webkit-animation: Tada 3s both infinite;
            -moz-animation: Tada 3s both infinite;
            -ms-animation: Tada 3s both infinite;
            animation: Tada 3s both infinite; */
}

.subscribe-icon,
.subscribe-cont {
  height: 80px;
  text-align: center;
  line-height: 80px;
  position: relative;
}

.subscribe-icon {
  width: 150px;
  padding-left: 30px;
  box-sizing: border-box;
  background: linear-gradient(to right, #f3c988, #f9e0b8);
  border-radius: 40px 0 0 40px;
}

.subscribe-icon::after {
  position: absolute;
  content: '';
  right: -50px;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 80px solid #f9e0b8;
  border-right: 50px solid transparent;
  z-index: 9;
}

.subscribe-cont {
  width: calc(100% - 150px);
  background: linear-gradient(to right, #f3c988, #f9e0b8);
  border-radius: 0 40px 40px 0;
  font-weight: 600;
}

.subscribe-cont text {
  display: inline-block;
  -webkit-animation: subscribeCont 1s linear infinite;
  animation: subscribeCont 1s linear infinite;
}

@keyframes subscribeCont {
  25% {
    transform: scale(.98);
  }

  50%,
  100% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.05);
  }
}

.subscribe-icon image {
  width: 54px;
  height: 54px;
  margin-top: 14px;
}

@keyframes Tada {
  0% {
    transform: scale(1);
    transform: scale(1)
  }

  70%,
  73% {
    transform: scale(1) rotate(-3deg);
    transform: scale(1) rotate(-3deg)
  }

  77%,
  83%,
  90%,
  97% {
    transform: scale(1) rotate(3deg);
    transform: scale(1) rotate(3deg)
  }

  80%,
  87%,
  93% {
    transform: scale(1) rotate(-3deg);
    transform: scale(1) rotate(-3deg)
  }

  100% {
    transform: scale(1) rotate(0);
    transform: scale(1) rotate(0)
  }
}

.subscribe-icon-one {
  -webkit-animation: bounce-right 1s linear infinite;
  animation: bounce-right 1s linear infinite;
}

@keyframes bounce-right {
  25% {
    transform: translateX(-3px);
  }

  50%,
  100% {
    transform: translateX(0);
  }

  75% {
    transform: translateX(3px);
  }
}

.subscribe-icon-two {
  -webkit-animation: bounce-two 1s linear infinite;
  animation: bounce-two 1s linear infinite;
}

@keyframes bounce-two {
  25% {
    opacity: 0;
    transform: translateX(-3px);
  }

  75% {
    opacity: 1;
    transform: translateX(3px);
  }
}

subscribe-btn {
  width: 100%;
  height: 200px;
  text-align: center;
  line-height: 150px;
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
  background-color: green;
  position: relative;
  overflow: hidden;
}
#subscribe-btn{
  width: 100%;
  height: 200px;
  text-align: center;
  line-height: 150px;
  font-size: 30px;
  font-weight: 500;
  color: #ffffff;
  background-color: green;
  position: relative;
  overflow: hidden;
}
.launch-btn-box,#launch-btn{
  border: 2px solid #66a8cc;width: 500px;height: 88px;margin: 50px auto;text-align: center;
  color: #282828;
}
</style>
